import { isNull } from '../Types/isNull';
import { isUndefined } from '../Types/isUndefined';
import { forEach } from './forEach';
import { getListType, getNewList, setListValue } from './listAccess';
import { getPath } from './Paths/getPath';
/**
 * Can be used to sort arrays containing objects by a property of said objects
 * Can also be used to sort plain objects, containing other objects in the same way
 *
 * @param list the list to sort
 * @param by The property of the child objects to sort by
 * @param desc If set to true the result will be sorted descending instead of the default which is ascending
 */
export function sort(list, by, desc) {
    // Build the sorter
    var sorter = [];
    forEach(list, function (v, k) {
        sorter.push({
            by: isNull(by) || isUndefined(by) ? v : getPath(v, by),
            k: k,
            v: v
        });
    });
    // Sort the sorter array
    sorter = sorter.sort(function (a, b) {
        return desc ?
            ((a.by > b.by) ? -1 : ((a.by < b.by) ? 1 : 0)) :
            ((a.by < b.by) ? -1 : ((a.by > b.by) ? 1 : 0));
    });
    // Build result
    var result = getNewList(getListType(list));
    forEach(sorter, function (o) { return setListValue(result, o.v, o.k); });
    return result;
}
//# sourceMappingURL=sort.js.map